import { render, staticRenderFns } from "./BatchDelete.vue?vue&type=template&id=20a96b3c"
import script from "./BatchDelete.vue?vue&type=script&lang=js"
export * from "./BatchDelete.vue?vue&type=script&lang=js"
import style0 from "./BatchDelete.vue?vue&type=style&index=0&id=20a96b3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports